<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content" *ngIf="Mode=='New'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Insemination

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" (ngSubmit)="onSubmit()" novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Technique</label>
                      </div>
                      <div class="col-md-4">
                        <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->
                        <CodeTypeValue CodeType="InsTe" id="CurrentSaveIvfCycleInseminationInfoRequest.Technique"
                                       [(ngModel)]="CurrentSaveIvfCycleInseminationInfoRequest.Technique" SelectedValue=""
                                       name="CurrentSaveIvfCycleInseminationInfoRequest.Technique" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px ">
                        <label for="diaplayName" class="margin-bottom-0px">Injected/Inseminated</label>
                      </div>
                      <div class="col-md-2 padding-right-0px">

                        <!--<input type="text" class="form-control" placeholder="" [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.OccCount"
                        maxlength="2" required>-->
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveIvfCycleInseminationInfoRequest.OocyteCount"
                                       [(ngModel)]="CurrentSaveIvfCycleInseminationInfoRequest.OocyteCount" SelectedValue=""
                                       name="CurrentSaveIvfCycleInseminationInfoRequest.OocyteCount" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>


                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Details</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <input type="text" class="form-control" id="CurrentSaveIvfCycleInseminationInfoRequest.Remarks"
                               [(ngModel)]="CurrentSaveIvfCycleInseminationInfoRequest.Remarks"
                               name="CurrentSaveIvfCycleInseminationInfoRequest.Remarks"
                               placeholder="Details" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-7px">Embryologist </label>
                      </div>
                      <div class="col-md-4 ">
                        <!--<label class="margin-top-7px">{{ProviderName}}</label>-->
                        <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy" SelectedValue="CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy"
                                                 [(ngModel)]="CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy" (keyChange)="onAssignedToActorCodeEmbryologist2($event)"
                                                 name="CurrentSaveIvfCycleInseminationInfoRequest.PrescribedBy">
                        </CustomDataByRequestType>

                      </div>
                      <!--<div class="col-md-2 padding-left-0px margin-top-5px">

                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="DoctorSelection()"> <i class="fas fa-ellipsis-h"></i></button>
                      </div>-->
                    </div>


                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="Mode=='Edit'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Insemination

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmitEdit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Technique</label>
                      </div>
                      <div class="col-md-4">
                        <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->
                        <CodeTypeValue CodeType="InsTe" id="CurrentEditIvfCycleInseminationInfoRequest.Technique"
                                       [(ngModel)]="CurrentEditIvfCycleInseminationInfoRequest.Technique" SelectedValue=""
                                       name="CurrentEditIvfCycleInseminationInfoRequest.Technique" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px ">
                        <label for="diaplayName" class="margin-bottom-0px">Injected/Inseminated</label>
                      </div>
                      <div class="col-md-2 padding-right-0px">

                        <!--<input type="text" class="form-control" placeholder="" [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.OccCount"
                        maxlength="2" required>-->
                        <CodeTypeValue CodeType="1to20" id="CurrentEditIvfCycleInseminationInfoRequest.OocyteCount"
                                       [(ngModel)]="CurrentEditIvfCycleInseminationInfoRequest.OocyteCount" SelectedValue=""
                                       name="CurrentEditIvfCycleInseminationInfoRequest.OocyteCount" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>


                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Details</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <input type="text" class="form-control" id="CurrentEditIvfCycleInseminationInfoRequest.Remarks"
                               [(ngModel)]="CurrentEditIvfCycleInseminationInfoRequest.Remarks"
                               name="CurrentEditIvfCycleInseminationInfoRequest.Remarks"
                               placeholder="Details" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-7px">Embryologist </label>
                      </div>
                      <div class="col-md-4 ">
                        <!--<label class="margin-top-7px" *ngIf="Displayold">{{CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName}}</label>
                        <label class="margin-top-7px" *ngIf="Displaynew">{{ProviderName2}}</label>-->
                        <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy" SelectedValue="CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy"
                                                 [(ngModel)]="CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy" (keyChange)="onAssignedToActorCodeEmbryologist3($event)"
                                                 name="CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy">
                        </CustomDataByRequestType>
                        <!--<CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName" SelectedValue="CurrentEditIvfCycleInseminationInfoRequest.ProviderCode2"
                                                 [(ngModel)]="CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName" (keyChange)="onAssignedToActorCodeEmbryologist3($event)"
                                                 name="CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName" *ngIf="Displaynew">
                        </CustomDataByRequestType>-->

                      </div>
                      <!--<div class="col-md-2 padding-left-0px margin-top-5px">

                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="DoctorSelection2()"> <i class="fas fa-ellipsis-h"></i></button>
                      </div>-->
                    </div>


                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

